module.exports = __webpack_public_path__ + "static/media/smartstream.43164705.png";